export function surveyLink(guid, absolute = true, appendJwt = false, surveyResponseId = -1, questionId = null) {
  let url;

  url = '/s/' + guid;
  url = process.env.ANKIETEO_FRONTEND + url;

  if(appendJwt && localStorage.jwt){
    url += '?auth=' + localStorage.jwt;
  }

  if (questionId) {
    url += '&question=' + questionId;
  }

  if (surveyResponseId > 0) {
    url += '&id=' + surveyResponseId;
  }



  return url;
}
